var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M59.96 47.84L10.52 0 2.9 7.55l41.86 40.6-42.02 44.6 8.19 7.25 49.03-52.16zM40.04 92.75l8.18 7.25 49.04-52.16L47.8 0 40.2 7.55l41.85 40.6-42.01 44.6z", "fill-rule": "nonzero" } }] }, name: "next", theme: "outlined" };
export {
  e as default
};
